<template>
  <div class="jf-window job-invoices">
    <a href="javascript:;" class="toggle open" @click="$emit('close')">INVOICES</a>
    <a href="javascript:;" class="plus" v-tooltip="'Add invoice'" @click="showModalAdd = true">+</a>
    <ul v-if="JOB_INVOICES.length">
      <li v-for="(invoice, index) in JOB_INVOICES" :key="index">
        <div class="details">
          <div class="no">#{{ invoice.invoice_number }}</div>
          <div class="name">
            <router-link :to="{name: 'invoice', params: {invoiceId: invoice.id}}" class="black">{{ invoice.name }}</router-link>
          </div>
        </div>
        <div class="actions">
          <a href="javascript:;" class="icon-copy" v-tooltip="'Duplicate invoice'" @click="confDuplicate(index)"></a>&nbsp;
          <a href="javascript:;" class="icon-trash" v-tooltip="'Delete invoice'" @click="confDelete(index)"></a>
        </div>
      </li>
    </ul>
    <div v-if="totalInvoicedAmount" class="tt">
      INVOICED TO DATE: ${{ totalInvoicedAmount | numberFormat }}
    </div>
    <modal-add-invoice v-model="showModalAdd" :job="JOB" @added="onAdded"></modal-add-invoice>
  </div>
</template>

<script>
  import {mapGetters} from 'vuex'
  import ServiceInvoice from '@/services/invoice'
  import ModalAddInvoice from '@/components/invoices/ModalAddInvoice'
  import ModalDuplicate from '@/components/invoices/ModalDuplicate'
  export default {
    components: {
      ModalAddInvoice,
    },
    data() {
      return {
        showModalAdd: false
      }
    },
    watch: {},
    computed: {
      ...mapGetters(['JOB', 'JOB_INVOICES']),
      totalInvoicedAmount: function () {
        let self = this, total = 0;
        for (var i in self.JOB_INVOICES) {
          total += self.JOB_INVOICES[i].total_value;
        }
        return total;
      }
    },
    created() {
    },
    mounted() {
      this.init();
    },
    methods: {
      init() {
        this.showModalAdd = false;
      },
      onAdded(invoice) {
        this.$store.dispatch('ADD_JOB_INVOICE', invoice);
      },
      confDuplicate(index) {
        let self = this;
        self.JOB_INVOICES[index].client = self.JOB.client;
        self.$modal.show(ModalDuplicate, {
          index: index,
          invoice: self.JOB_INVOICES[index],
          on_job_view: true
        }, {
          clickToClose: false,
          width: 592
        });
      },
      confDelete(index) {
        let self = this, item = self.JOB_INVOICES[index];
        self.$dialog
          .confirm('Are you sure you want to delete invoice <strong>' + item.name + '</strong>?', {
            html: true,
            loader: true,
            okText: "Yes, I'm sure",
            cancelText: "Cancel",
          })
          .then(dialog => {
            ServiceInvoice.delete(item.id, function(resp){
              dialog.close();
              if (resp.status == 'FAILED') {
                self.$notify({
                  type: 'error',
                  text: resp.error,
                });
              } else {
                self.JOB_INVOICES.splice(index, 1);
                self.$notify({
                  type: 'success',
                  text: 'Invoice <strong>' + item.name + '</strong> has been deleted'
                });
                self.$store.dispatch('GET_JOB', self.JOB.id);
              }
            });
          })
          .catch(() => {
          })
        ;
      },
    }
  }
</script>
